/**
 * Starts a new bark for a category via the hidden new-bark form that
 * bark-core renders on every buyer page: populate the hidden inputs,
 * then trigger the hidden submit.
 *
 * @param {Object} opts
 * @param {number|string} opts.categoryId
 * @param {string} opts.barkMode Analytics/behaviour mode sent with the new bark
 */
export const startNewBark = ({ categoryId, barkMode }) => {
	$('#category_id').val(categoryId);
	$('#postcode_id').val('-1');
	$('#postcode_type').val('-1');
	$('#category_name_hidden').val('');
	$('#bark_mode').val(barkMode);
	$('#bark_submit').trigger('click');
};
